<button [ngClass]="[customClasses, styleClass, subStyle, animateClass]"
        [disabled]="disabled"
        (click)="clicked.emit()"
        [type]="type"
        [style.minWidth.px]="minWidth"
        [style.minHeight.px]="minHeight"
        [ngStyle]="{'justify-content': justifyTextPosition}"
        #appButton
        [tabIndex]="-1"
        (keydown.tab)="keydownTab.emit()"
        (keydown.Enter)="clicked.emit()"
>
  <img *ngIf="icon && iconPosition !== ButtonIconPositions.Right"
    class="left"
    [src]="'assets/icons/' + icon + '.svg'" 
    [alt]="icon" 
    [class.centered]="iconPosition == ButtonIconPositions.Center"/>
  <span *ngIf="!loading" class="text">
    {{text}}
  </span>
  <img *ngIf="icon && iconPosition === ButtonIconPositions.Right"
    class="right"
    [src]="'assets/icons/' + icon + '.svg'" 
    [alt]="icon" />
  <svg *ngIf="loading"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
       y="0px" viewBox="0 0 50 50"
       xml:space="preserve"
  >
  <path fill="#000"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
  >
    <animateTransform attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="0.6s"
                      repeatCount="indefinite"
    />
    </path>
  </svg>

  <!-- for complex content structures -->
  <ng-content></ng-content>
</button>
